import { render, staticRenderFns } from "./SkeletonConfirmDialog.vue?vue&type=template&id=73a64983&scoped=true&"
import script from "./SkeletonConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./SkeletonConfirmDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a64983",
  null
  
)

export default component.exports